import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'What are fluid transfer pumps used for?',
  answer: 'Fluid transfer pumps move liquids from one place to another — including water, fuel, oil, and chemicals. In marine, RV, and industrial settings, they handle tasks like refueling, oil changes, emptying holding tanks, washdown, and industrial process fluid movement.'
}, {
  question: 'What types of pumps are commonly used on boats?',
  answer: 'Boats commonly use bilge pumps (to remove water from the hull), engine cooling (raw water) pumps, freshwater pumps for sinks and showers, washdown pumps for cleaning the deck, and macerator pumps for waste holding tanks.'
}, {
  question: 'How do I choose the right pump?',
  answer: 'Match the pump to the fluid (water, fuel, oil, chemical), required flow rate, available power (12V, 24V, 115V, 230V), and whether the pump needs to self-prime or be submersed. If you are unsure, fill out our help form and we will help you identify the correct pump.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white" data-id="element-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-21">
        <div className="mb-6" data-id="element-22">
          <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-2" data-id="element-23">
            Frequently Asked Questions
          </h2>
          <p className="text-slate-600" data-id="element-24">
            Common questions about marine and industrial pumps.
          </p>
        </div>

        <div className="space-y-3" data-id="element-25">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className={`border rounded-lg overflow-hidden transition-colors duration-150 ${isOpen ? 'border-marine-blue/40 bg-marine-light/30' : 'border-slate-200 bg-white'}`} data-id="element-26">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="w-full flex items-center justify-between p-4 text-left focus:outline-none focus:ring-2 focus:ring-marine-blue/30" data-id="element-27">
                  <span className="font-semibold text-slate-900 pr-6 text-sm sm:text-base" data-id="element-28">
                    {faq.question}
                  </span>
                  <div className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors duration-150 ${isOpen ? 'bg-marine-blue text-white' : 'bg-slate-100 text-slate-500'}`} data-id="element-29">
                    <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-30" />
                  </div>
                </button>

                <AnimatePresence initial={false} data-id="element-31">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-32">
                      <div className="px-4 pb-4 text-sm text-slate-600 leading-relaxed" data-id="element-33">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}